import { setJwtToken } from '@/helpers/setRequestHeaders'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export type AnimalNeed = {
    id: number,
    title: string,
    value: string,
    icon: string 
}

type AnimalNeedDto = {
    title: string,
    value: string,
    icon: string 
}

export const animalNeedsApi = createApi({
    reducerPath: 'animalNeedsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NEXT_PUBLIC_API_ENDPOINT || 'http://megakorm.ru:3005/api',
        prepareHeaders: setJwtToken
    }),
    tagTypes: ["ANIMAL-NEEDS"],
    endpoints: builder => ({
        getAllAnimalNeeds: builder.query<AnimalNeed[], void>({
            query: () => ({ url: `/animal-needs` }),
            providesTags: ["ANIMAL-NEEDS"]
        }),
        getAllAnimalNeedsEn: builder.query<AnimalNeed[], void>({
            query: () => ({ url: `/animal-needs?lang=en` }),
            providesTags: ["ANIMAL-NEEDS"]
        }),
        getAnimalNeed: builder.query<AnimalNeed, { id: number }>({
            query: ({ id }) => ({ url: `/animal-needs/${id}` }),
            providesTags: ["ANIMAL-NEEDS"]
        }),
        createAnimalNeed: builder.mutation<any, AnimalNeedDto>({
            query: (body) =>({url: `/animal-needs`, method: "POST", body: body}),
            invalidatesTags: ["ANIMAL-NEEDS"],
        }),
        deleteAnimalNeedsByIds: builder.mutation<any, any>({
            query: (data)=> ({url: `/animal-needs/delete-by-ids/del`, method: "POST", body: data}),
            invalidatesTags: ["ANIMAL-NEEDS"],
        }),
        updateAnimalNeeds: builder.mutation<any, any>({
            query: data => ({ url: `/animal-needs/${data.id}`, method: 'PATCH', body: data }),
            invalidatesTags: ["ANIMAL-NEEDS"],
        }),
        updateAnimalNeedsEn: builder.mutation<any, any>({
            query: data => ({
                url: `/animal-needs/en/update/${data.id}`,
                method: 'PATCH',
                body: { title: data.title }
            }),
            invalidatesTags: ['ANIMAL-NEEDS']
        })
    })
})

export const { useGetAllAnimalNeedsQuery, useGetAllAnimalNeedsEnQuery, useGetAnimalNeedQuery, useCreateAnimalNeedMutation, useDeleteAnimalNeedsByIdsMutation, useUpdateAnimalNeedsMutation, useUpdateAnimalNeedsEnMutation } = animalNeedsApi
